import styled from '@emotion/styled';

import Grid from '@mui/material/Grid';

export default styled(Grid)`
  margin-top: 60px;

  .general_info { 
    &__title {
      color: #161728;
      font-family: Sofia Pro;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
    }

    &__subtitle {
      color: #5C5D68;
      font-family: Sofia Pro;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    &__form-container {
      background-color: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #F0F0F0;
      max-width: 350px;
    }
    
    &__upload-button {
      background-color: #05B2DC;
      color: #FFF;
      border-radius: 10px;
      font-size: 14px;
      text-transform: none;
      padding: 5px 10px;
    }

    &__text-input {
      padding: 3px 8px;
      border-radius: 10px;
      background: #F0F0F0;
      margin: 6px 0;
    }

    &__submit-button-container {
      margin-top: 16px;
      max-width: 350px;
    }

    &__submit-button {
      width: 350px;
    }
  }
`;
